function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffda44",
  d: "M0 85.331h512v341.337H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 85.331h170.663v341.337H0zm341.337 0H512v341.337H341.337z",
  fill: "#0052b4"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M307.942 189.212l9.955 4.978-9.955-4.978-9.955-4.978c-.6 1.201-13.599 27.649-15.723 68.05H267.13v-63.073L256 174.372l-11.13 14.84v63.073h-15.133c-2.124-40.401-15.123-66.849-15.723-68.05l-19.911 9.955c.137.273 13.666 27.811 13.666 69.226v11.13h37.101v63.073h22.261v-63.073h37.101v-11.13c0-21.413 3.705-39.068 6.813-50.109 3.389-12.04 6.831-19.072 6.865-19.141l-9.968-4.954z"
});

const SvgBarbados = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBarbados, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/barbados.8a4d3733.svg";
export { ForwardRef as ReactComponent };